export const isCookieConsentRequired = JSON.parse(process.env.REACT_APP_COOKIE_CONSENT);
